import "core-js/stable";
import { LoginRouter } from "@/auto-converted/routers/LoginRouter";
import { Cvpartner, setCvPartner } from "../Cvpartner";
import "./application_styles";
import "../components/navigation";

// Here be dragons
setCvPartner(new Cvpartner(LoginRouter));
